import { render, staticRenderFns } from "./amc-wizard.vue?vue&type=template&id=5d31f23a"
import script from "./amc-wizard.vue?vue&type=script&lang=js"
export * from "./amc-wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports